export default __webpack_public_path__ + "static/media/events-empty.887a507f.png";